export default function getValidIdReducer(state = {validUserIdState:(localStorage.getItem("validUserId") ? JSON.parse(localStorage.getItem("validUserId")) : "")}, action) {
    switch (action.type) {
        case 'GET_VALIDUSERID':
            return {
                validUserIdState: action.validUserIdState
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/getvalididreducer.jsx